import { Suspense, lazy, useEffect } from 'react';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import NotFound from 'views/NotFound/presentational';
import { Loader, Layout } from 'components';
import { useSelector } from 'react-redux';
import ScrollToTop from 'utils/ScrollTop';
import { useHistory, useRouteMatch } from 'react-router';
import { useLanguage } from 'hooks/i18n';
import Routes from './routes';

const Presentation = lazy(() => import('views/Presentation'));

const Redirector = () => {
  const { roleRoutes = 'public' } = useSelector(({ AppReducer = {} }) => AppReducer);

  const { params } = useRouteMatch();
  const [language, setLanguage] = useLanguage();
  const history = useHistory();

  useEffect(() => {
    if (!params.language) {
      history.replace(`/${language}`);
    }
    if (params.language !== language) {
      setLanguage(params.language);
    }
  }, [params, language, setLanguage, history]);

  return (
    <Switch>
      {Routes[roleRoutes].map(({ key, ...routeProps }) => (
        <Route {...routeProps} key={key} />
      ))}
      <Route component={NotFound} />
    </Switch>
  );
};

const MainRoutes = () => (
  <Layout>
    <Redirector />
  </Layout>
);

export default function Router() {
  return (
    <Suspense fallback={<Loader fullAppLoader />}>
      <BrowserRouter>
        <ScrollToTop>
          <Switch>
            <Route
              path="/presentations/:namePresentation"
              exact
              component={Presentation}
            />
            <Route path="/:language?/" component={MainRoutes} />
            <Route component={NotFound} />
          </Switch>
        </ScrollToTop>
      </BrowserRouter>
    </Suspense>
  );
}
